import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class WinRatetPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="well">
          <code>
            TODO: Win Rate Leaderboard
          </code>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

WinRatetPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

WinRatetPage.defaultProps = {
};

WinRatetPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(WinRatetPage);
